/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Polish (Poland)
export default {
  'fabric.linkPicker.button.cancel': 'Anuluj',
  'fabric.linkPicker.button.insert': 'Wstaw',
  'fabric.linkPicker.button.save': 'Zapisz',
  'fabric.linkPicker.clearLink': 'Wyczyść',
  'fabric.linkPicker.clearLinkText': 'Wyczyść tekst',
  'fabric.linkPicker.hyperlink.searchLinkResults': '{count, plural, =0 {Nie znaleziono wyników} one {Znaleziono {count,number} wynik} few {Znaleziono {count,number} wyniki} many {Znaleziono {count,number} wyników} other {Znaleziono {count,number} wyniku}}',
  'fabric.linkPicker.linkAriaLabel': 'Wpisz lub wklej łącze w polu',
  'fabric.linkPicker.linkHelperTextAriaLabel': 'Tekst pomocy dotyczący wyświetlania łącza',
  'fabric.linkPicker.linkHelperTextLabel': 'Nadaj temu łączu tytuł lub opis',
  'fabric.linkPicker.linkInvalid': 'Wprowadź prawidłowy adres URL.',
  'fabric.linkPicker.linkLabel': 'Łącze',
  'fabric.linkPicker.linkPlaceholder': 'Wklej łącze',
  'fabric.linkPicker.linkTextAriaLabel': 'Tekst wyświetlany łącza',
  'fabric.linkPicker.linkTextLabel': 'Tekst wyświetlany (opcjonalny)',
  'fabric.linkPicker.linkTextPlaceholder': 'Tekst do wyświetlenia',
  'fabric.linkPicker.listTitle.recentlyViewed': 'Ostatnio wyświetlane',
  'fabric.linkPicker.listTitle.results': 'Wyniki',
  'fabric.linkPicker.search.error.description': 'Odśwież stronę lub skontaktuj się z <a>działem wsparcia Atlassian</a>, jeśli sytuacja będzie się powtarzać.',
  'fabric.linkPicker.search.error.heading': 'Wystąpił problem podczas ładowania danych.',
  'fabric.linkPicker.search.error.retry': 'Odśwież',
  'fabric.linkPicker.search.linkAriaLabel': 'Sugestie będą pojawiały się poniżej w miarę wpisywania tekstu w polu',
  'fabric.linkPicker.search.linkLabel': 'Wyszukaj lub wklej łącze',
  'fabric.linkPicker.search.linkPlaceholder': 'Znajdź ostatnie łącza lub wklej nowe łącze',
  'fabric.linkPicker.search.noResults.description': 'Spróbuj ponownie, wybierając inne wyrażenie.',
  'fabric.linkPicker.search.noResults.heading': 'Nie można znaleźć dopasowań do wyszukiwania.',
  'fabric.linkPicker.status.submitting': 'Przesyłanie',
  'fabric.linkPicker.time.message.updated': 'Zaktualizowano {time}',
  'fabric.linkPicker.time.message.viewed': 'Wyświetlono {time}',
  'fabric.linkPicker.unhandledError.description': 'Spróbuj załadować stronę ponownie.',
  'fabric.linkPicker.unhandledError.heading': 'Coś poszło nie tak'
};